import Vue from 'vue'
import Router from 'vue-router'
import { isEmbedded, embedHandoff } from '@/service/embed-mode'
import storage from '@/service/storage-service'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '',
  routes: [{
      path: '',
      redirect: '/index'

    },
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'Index',
      component: resolve => require(['@/components/Index'], resolve)
    },
    {
      path: '/project',
      name: 'Project',
      component: resolve => require(["@/components/Project"], resolve)
    },
	{
	  path: '/project-control',
	  name: 'ProjectDeviceControl',
	  component: resolve => require(["@/components/ProjectDeviceControl"], resolve)
	},
	{
	  path: '/login',
	  name: 'Login',
	  component: resolve => require(["@/components/Login"], resolve)
	},
	{
	  path: '/sso',
	  name: 'SsoLogin',
	  component: resolve => require(["@/components/SsoLogin"], resolve)
	},
  ]
})
if (isEmbedded) {
  router.beforeEach((to, from, next) => {
    // 文档刷新后内存令牌为空，重新握手；不进入独立登录或借用其他窗口会话。
    const path = to.path === '/login' || (!storage.getUser() && to.path !== '/sso') ? '/sso' : to.path
    if (path !== to.path || to.query.embed !== '1' || to.query.handoff !== embedHandoff.handoff) {
      next({ path, query: Object.assign({}, to.query, embedHandoff), replace: true })
    } else next()
  })
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js